class MyDeliverySaverManagementController {
    constructor($state, $scope, $filter, myDeliverySaverService, dialogRegistry, settings) {
        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.myDeliverySaverService = myDeliverySaverService;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
    }

    $onInit() {
        this.loading = false;
        this.dialog = {
            CANCEL_CONFIRM: 'SUBSCRIPTION_CANCEL_CONFIRM',
            CANCEL_CONFIRMED: 'SUBSCRIPTION_CANCEL_CONFIRMED',
        };

        const endDate = this.$filter('date')(this.myDeliverySaverService.subscription.NextBillingDate, 'd MMMM, yyyy');
        const startDate = this.$filter('date')(this.myDeliverySaverService.subscription.StartDate, 'd MMMM, yyyy');
        const totalDiscount = this.$filter('currency')(this.myDeliverySaverService.totalDiscount);

        this.cancelSubscriptionConfirmationModalHtml = this.settings.deliverySaver.cancelSubscriptionConfirmationModalHtml
            .replace('{{ StartDate }}', startDate)
            .replace('{{ TotalDiscount }}', totalDiscount)
            .replace('{{ EndDate }}', endDate);

        this.cancelSubscriptionConfirmedModalHtml = this.settings.deliverySaver.cancelSubscriptionConfirmedModalHtml
            .replace('{{ EndDate }}', endDate);
    }

    confirmCancel() {
        this.cancelDialog = this.dialogRegistry.getDialog(this.dialog.CANCEL_CONFIRM);
        this.cancelDialog.show();
    }

    cancelSubscription() {
        this.loading = true;
        this.myDeliverySaverService.cancelSubscription().then(() => {
            this.loading = false;
            this.dialogRegistry.getDialog(this.dialog.CANCEL_CONFIRMED).show();
            this.cancelDialog.close();
        });
    }
}

MyDeliverySaverManagementController.$inject = ['$state', '$scope', '$filter', 'MyDeliverySaverService', 'DialogRegistry', 'Settings'];

const MyDeliverySaverManagementComponentDefinition = {
    controller: MyDeliverySaverManagementController,
    template: require('./my-delivery-saver-management.component.html').trim(),
};

module.exports = {
    MyDeliverySaverManagementController,
    MyDeliverySaverManagementComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/mydeliverysaver/management/my-delivery-saver-management.component.js